import { Box, lighten } from "@mui/material";

export default function StyledCircleOverlay({ color }: { color: string }) {
  return (
    <Box
      sx={{
        top: 0,
        right: 0,
        width: "180px",
        height: "180px",
        position: "absolute",
        transform: "translate(50%, -50%)",
        borderRadius: "50%",
        boxSizing: "border-box",
        border: `25px solid ${lighten(color, 0.8)}`,
      }}
    />
  );
}
